import React from 'react'
import GiphyTV from '@giphy/react-giphy-tv'
import { TVProps } from './tv-util'

const TV = (tvProps: TVProps) => {
    const { width, height, left, top } = tvProps
    return (
        <div
            style={{
                width,
                height,
                left,
                top,
                position: 'absolute',
            }}
        >
            <GiphyTV {...tvProps} apiKey="3eFQvabDx69SMoOemSPiYfh9FY0nzO9x" />
        </div>
    )
}
export default TV
